/**
 * Хуки движка автозаявок (вкладка «Уборка/Автозаявки», housekeeping wave).
 * Server-state только через React Query (патент проекта).
 *
 * Поверх бэка /v1/request-rules (internal/request/autotasks).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createAutoTaskRule,
  deleteAutoTaskRule,
  listAutoTaskRules,
  updateAutoTaskRule,
  type AutoTaskRule,
  type CreateAutoTaskRuleInput,
  type UpdateAutoTaskRuleInput,
} from '@hsc/api-client';

export const AUTO_TASK_RULES_KEY = ['auto-task-rules'] as const;

export function useAutoTaskRules() {
  return useQuery<AutoTaskRule[]>({
    queryKey: AUTO_TASK_RULES_KEY,
    queryFn: listAutoTaskRules,
    staleTime: 30_000,
  });
}

export function useCreateAutoTaskRule() {
  const qc = useQueryClient();
  return useMutation<AutoTaskRule, Error, CreateAutoTaskRuleInput>({
    mutationFn: createAutoTaskRule,
    onSuccess: () => void qc.invalidateQueries({ queryKey: AUTO_TASK_RULES_KEY }),
  });
}

export function useUpdateAutoTaskRule() {
  const qc = useQueryClient();
  return useMutation<AutoTaskRule, Error, { id: string; input: UpdateAutoTaskRuleInput }>({
    mutationFn: ({ id, input }) => updateAutoTaskRule(id, input),
    onSuccess: () => void qc.invalidateQueries({ queryKey: AUTO_TASK_RULES_KEY }),
  });
}

export function useDeleteAutoTaskRule() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: deleteAutoTaskRule,
    onSuccess: () => void qc.invalidateQueries({ queryKey: AUTO_TASK_RULES_KEY }),
  });
}
